import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useRef } from 'react';
import '../../App.css';
import '../../css/bootstrap.scss';
import user_icon from "../../images/reg_user.png";
import { Link } from 'react-router-dom';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import { useNavigate } from 'react-router-dom';
import BackButton from '../Includes/BackButton';
import verify_id_icon1 from "../../images/verify_id_icon1.png";
import verify_id_icon2 from "../../images/verify_id_icon2.png";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function VerifyIdMethod() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);

    return (
        <>
            <Header />
            <Container fluid className='bg-sky min-vh-custom'>
                <Row>
                    <Col md={12}>
                        <div className='mt-5'>
                            <Col md={3} className='text-center py-4'>
                                <Row className='justify-content-center'>
                                    <BackButton />
                                </Row>
                            </Col>

                            <Col md={12} className='text-center justify-content-center'>
                                <img src={user_icon} width={50} />
                                <h3 className='text-center mt-3 mb-4'>{t('login.secure_title')}</h3>

                                <Row className='justify-content-center text-center'>
                                    <Col md={4} className='bg-white rounded-3' style={{ width: '540px' }}>
                                        <Form noValidate validated={validated}>
                                            <Row>
                                                <label className="form-label fw-bold py-3">{t('login.verify_id_title')}</label>
                                            </Row>
                                            <Row className='justify-content-center mb-3'>
                                                <Col md={5} className='rounded-4 bg-sky'>
                                                    <div className='d-flex align-items-center p-2'>
                                                        <img className='text-center' src={verify_id_icon1} width={32} alt='Image' onClick={() => { navigate('/secure_identity_verify_methods') }} />
                                                        <p className='text-black my-0 small text-start px-2 fw-medium' onClick={() => { navigate('/secure_identity_verify_methods') }}>{t('login.verify_phone_option')}</p>
                                                    </div>
                                                </Col>

                                                <Col md={5} className='rounded-4 bg-sky ms-3'>
                                                    <div className='d-flex align-items-center p-2'>
                                                        <img className='text-center' src={verify_id_icon2} width={32} alt='Image' />
                                                        <p className='text-black my-0 small text-start px-2 fw-medium'>{t('login.verify_webcam')}</p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Col>
                                </Row>
                            </Col>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Footer full={true} />
        </>
    );
}

export default VerifyIdMethod;
